import React, { Component } from 'react'
import vMasker from 'vanilla-masker'
import { TextField } from '@mui/material'
import { injectIntl } from 'react-intl'

import FieldRowWrapper from '../FieldRowWrapper/FieldRowWrapper'
import FieldWrapper from '../FieldRowWrapper'
import RawHtml from 'stories/components/RawHtml'
import {
  ensureEnglishNumber,
  toPersianDigit,
} from '../../../helpers/generalHelpers'
import { getRawMessage } from '../../../locale'
import settings from '../../../settings'

import './phone-number-input.css'

const { locales } = settings

export const defaultPhoneTypeOptions = [
  { value: 'mobile', label: getRawMessage('form.fields.phone.types.mobile') },
  {
    value: 'landline',
    label: getRawMessage('form.fields.phone.types.landline'),
  },
  { value: 'both', label: getRawMessage('form.fields.phone.types.both') },
]

class PhoneNumberInput extends Component {
  constructor(props) {
    super(props)
    this.state = { hasFocus: false, maskedValue: '' }
  }

  maskMobileNumber = (rawValue) => {
    return vMasker.toPattern(rawValue, '9999-9999999')
  }

  unMaskMobileNumber = (rawValue) => {
    return rawValue.replace('-', '')
  }

  onInputChange = (event) => {
    this.updateState({
      value: event.target.value,
      shouldUpdateParent: true,
    })
  }

  onInputFocus = () => {
    this.setState({ hasFocus: true }, () => {
      this.props.onFocus && this.props.onFocus()
    })
  }

  onInputBlur = () => {
    this.setState({ hasFocus: false }, () => {
      this.props.onBlur && this.props.onBlur()
    })
  }

  getInputValue = () => {
    // if not persian just don't proceed.
    if (!this.shouldApplyMasking()) return this.props.value

    // mobile input is not controlled
    if (this.props.phone_type === 'mobile') {
      return toPersianDigit(this.state.maskedValue)
    } else {
      return toPersianDigit(this.props.value)
    }
  }

  componentDidMount = () => {
    // makes this component hybrid, if there is a value prop
    // it will respect it but otherwise it is independent 🍺 👍
    const { value } = this.props

    if (value) {
      this.updateState({
        value,
        shouldUpdateParent: false,
      })
    }
  }

  updateState = ({ value, shouldUpdateParent }) => {
    // first of all -> guarantee that the chars are converted to english
    const filteredAndEnglishedValue = ensureEnglishNumber(value)

    if (this.shouldApplyMasking() && this.props.phone_type === 'mobile') {
      // mask the filtered value, now it is guaranteed to be in english
      const maskedValue = this.maskMobileNumber(filteredAndEnglishedValue)
      this.setState({ maskedValue: maskedValue }, () => {
        // I'm not stupid, it is masked to ensure the format and then unmasked
        shouldUpdateParent &&
          this.props.onChange(this.unMaskMobileNumber(maskedValue))
      })
    } else {
      // no masking is needed for non-mobile type
      this.props.onChange(filteredAndEnglishedValue)
    }
  }

  shouldApplyMasking = () => {
    const {
      intl: { locale = locales.fa },
    } = this.props
    if (locale === locales.fa) return true

    return false
  }

  render() {
    const {
      label = '',
      name = '',
      placeholder,
      required,
      touched,
      error,
      description,
      customized,
    } = this.props

    const classNames = {
      'formz-phone-number-input': true,
      'formz-has-focus': this.state.hasFocus,
      'formz-has-error': this.props.error,
      'full-width': this.props.fullWidth,
    }
    const inputProps = {
      type: 'text',
      name,
      value: this.getInputValue(),
      placeholder,
      onChange: this.onInputChange,
      onFocus: this.onInputFocus,
      onBlur: this.onInputBlur,
    }
    if (customized)
      return (
        <FieldRowWrapper
          className={classNames}
          error={error}
          touched={touched ? touched.toString() : undefined}
        >
          <label className="formz-field-and-label-holder">
            <div className="formz-input-title">
              {label} {required && '(*)'}
            </div>
            <RawHtml
              className="formz-field-description"
              content={description}
            />
            <input {...inputProps} className="formz-input-field ltr-on-type" />
          </label>
        </FieldRowWrapper>
      )
    return (
      <FieldWrapper
        error={error}
        touched={touched ? touched.toString() : undefined}
        fullWidth={this.props.fullWidth}
      >
        <TextField {...inputProps} label={label} error={Boolean(error)} />
      </FieldWrapper>
    )
  }
}

export default injectIntl(PhoneNumberInput)
